import React, {
  FC,
} from 'react'

export interface HeaderProps {
  user: string | null;
  toCustomerHome?: (e: any) => void;
  logOut?: (e: any) => void;
}

const HeaderUserName: FC<HeaderProps> = ({ user, toCustomerHome = () => (null), logOut = () => (null) }) => {
  return (
    <li className="nav-item dropdown loggedIn">
      <a
        onClick={(e) => e.preventDefault()}
        href="#"
        data-toggle="dropdown"
        className="nav-link dropdown-toggle user-action"
      >
        <img src="images/man.png" className="avatar" alt="Avatar" />{' '}
        {user && (<span> {user} </span>)}
        <b className="caret" />
      </a>
      <ul className="dropdown-menu">
        <li>
          <a href="#" className="dropdown-item" onClick={(e) => toCustomerHome(e)}>
            <i className="fa " aria-hidden="true" />Vorige bestellingen
          </a>
        </li>
        <li>
          <a href="#" className="dropdown-item" onClick={logOut}>
            <i className="fa " />Uitloggen
          </a>
        </li>
      </ul>
    </li>
  )
}
export default HeaderUserName
